import { useState } from 'react';
import { m, AnimatePresence } from 'motion/react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    q: 'Rain Nova projesi ne zaman teslim edilecek?',
    a: 'Proje teslim tarihi 2026 yılının  son çeyreğidir. İnşaat aşamaları satış ofisimiz üzerinden düzenli olarak müşterilerimizle paylaşılmaktadır.',
  },
  {
    q: 'Hangi ödeme seçenekleri sunuluyor?',
    a: 'Anahtar teslimine kadar lansman fiyatları üzerinden satışlarımız devam etmektedir.',
  },
  {
    q: 'Daire fiyatları neye göre belirleniyor?',
    a: '8.000.000 TL den başlayan fiyatlarla fırsatlarımız devam etmektedir. Fiyatlandırma; daire metrekaresi, kat seviyesi, manzara yönü ve cephe tercihine göre değişmektedir. Detaylı fiyat listesi için satış ofisimizle iletişime geçebilirsiniz.',
  },
  {
    q: 'Aidat ücretleri ne kadar olacak?',
    a: 'Aidat ücreti site yönetimi tarafından belirlenecektir. Tahmini aidat ücreti daire metrekaresine göre, tüm sosyal donatıların kullanımı dahil olacak şekilde planlanacaktır.',
  },
  {
    q: 'Otopark hizmeti mevcut mu?',
    a: 'Proje planlamasında açık ve kapalı olmak üzere otopark alanları mevcuttur.',
  },
  {
    q: 'Sosyal donatılar 7/24 açık mı?',
    a: 'Fitness center ve diğer sosyal alanlar 06:00-24:00 saatleri arasında hizmet vermektedir. Güvenlik hizmetimiz 7/24 aktiftir.',
  },
];

export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-gray-50 dark:bg-slate-900">
      <div className="container mx-auto px-4 lg:px-8">
        <m.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 rounded-full text-sm tracking-wider mb-4">
            SIKÇA SORULAN SORULAR
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-slate-100 mb-6">
            Aklınıza Takılan{' '}
            <span className="text-stone-700 dark:text-stone-300">
              Her Şey
            </span>
          </h2>
        </m.div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <m.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="bg-white dark:bg-slate-950 rounded-xl shadow-sm border border-gray-100 dark:border-slate-800 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-slate-900 dark:text-slate-100 text-lg">{item.q}</span>
                  <span
                    className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? 'bg-slate-900 dark:bg-white text-white dark:text-slate-900' : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300'
                    }`}
                  >
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <m.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                    >
                      <div className="px-6 pb-5 text-gray-600 dark:text-gray-400 leading-relaxed">{item.a}</div>
                    </m.div>
                  )}
                </AnimatePresence>
              </m.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
